<template>
  <base-crud-page-create
    v-if="can('PROJECT_CREATE')"
    :back-url="{ name: 'mainProjects' }"
    :title="$tc('menu.project', 1)"
  >
    <template #form>

      <the-form :model="model" @emit:submit="save"/>

    </template>
  </base-crud-page-create>
</template>

<script>
import BaseCrudPageCreate from '../../../../components/BaseCrudPageCreate';
import FormService from '../../../../services/FormService';
import TheForm from '../components/TheForm';


export default {
  name: 'ProjectsCreate',
  components: {
    TheForm,
    BaseCrudPageCreate,
  },
  data() {
    return {
      model: new FormService({
        name: '',
        codeName: '',
        projectType: 'KANBAN',
        group: {
          id: 0
        },
        manager: {
          id: 0
        },
        organizationId: null,
        deadLine: null
      }),
    };
  },
  methods: {

    save() {
      let postData = this.model.GetData();
				postData.organizationId = this.$store.state.userProfile.organizationId
      this.$api
        .post('projects', postData)
        .then(response => {
          this.$router.push({name: 'mainProjects'});
        });
    },

  }
};
</script>
